module.exports = __webpack_public_path__ + "media/images/ui__themeToggleDark--dark-9fe0f6c8b8ce558cce1523fd03fa85c0.png";